import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ValueType } from '../../enums/value-type.enum';

@Component({
  selector: 'shared-labeled-value',
  imports: [CommonModule],
  templateUrl: './labeled-value.component.html',
  styleUrls: ['./labeled-value.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabeledValueComponent {
  @Input() value: number | string | undefined;
  @Input() valueSuffix: string | undefined;
  @Input() valueType: 'currency' | 'percentage' | 'text' = ValueType.CURRENCY;
  @Input() valueStyle: any | undefined;
  @Input() valueClass: string | undefined;
  @Input() label: string | undefined;
  @Input() isLabelVisible = true;
  @Input() image: string | undefined;

  readonly ValueType = ValueType;
}
